
const MapStyle = {

  maps: {
    left:'0',
    top:'0',
    height:'100% !important',
    width:'100% !important',
    position:'absolute',
      },
      mapres: {

      	overflow:'hidden',
    paddingBottom:'56.25%',
    position:'relative',
    height:'0',
      },
      
 title:{
 	color: "#3C4858",
	  margin: "1.25rem 0 0.75rem",
	  textDecoration: "none",
	  fontWeight: "400",
	  fontFamily: `"Helvetica Neue", "Helvetica", "Arial", "sans-serif"`
	  }
};
 
export default MapStyle;



// WEBPACK FOOTER //
// ./src/assets/jss/material-kit-react/views/landingPageSections/MapStyle.jsx